import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconRocket16(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={16}
            height={16}
            className={customClassName}
            name="IconRocket16"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M8.641 3.439c1.197-1.197 3.188-1.246 4.572-1.073a.52.52 0 0 1 .46.46c.174 1.384.125 3.375-1.072 4.572a18.1 18.1 0 0 1-5.573 3.76L4.881 9.011a18.1 18.1 0 0 1 3.76-5.572m4.667 4.666a18 18 0 0 1-1.803 1.576v2.263a.5.5 0 0 1-.23.42l-3.566 2.3c-.771.497-1.75-.222-1.506-1.107l.391-1.418-2.693-2.694-1.419.391C1.597 10.08.88 9.102 1.376 8.33l2.3-3.566a.5.5 0 0 1 .42-.23h2.262c.457-.596.98-1.206 1.576-1.802 1.556-1.557 3.99-1.535 5.403-1.358.703.088 1.24.626 1.328 1.328.178 1.414.199 3.847-1.357 5.403m-5.642 3.867a19 19 0 0 0 2.839-1.574v1.273l-3.337 2.152.48-1.747a.5.5 0 0 0 .018-.104M5.642 5.535H4.369L2.217 8.872l1.746-.481a.5.5 0 0 1 .105-.017c.303-.684.813-1.703 1.574-2.84m4.595.268a1.086 1.086 0 1 0 1.535-1.536 1.086 1.086 0 0 0-1.535 1.536"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconRocket16);
